// Module
var code = "<svg width=\"13\" height=\"16\" viewBox=\"0 0 13 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"> <path d=\"M11.6 6.58125L1.5 0.18125C0.8 -0.31875 0 0.28125 0 1.18125V13.9813C0 14.8813 0.8 15.4813 1.5 15.0813L11.6 8.68125C12.3 8.28125 12.3 6.98125 11.6 6.58125Z\" fill=\"white\"/> </svg> ";
// Exports
module.exports = code;